<template>
  <div
    class="wl-tag flex max-w-fit items-center gap-1 truncate rounded-full border font-medium leading-4"
    :class="[`type-${type}`, `size-${size}`, typeClasses, sizeClasses]"
  >
    <WLIcon v-if="icon" :name="icon" :size="IconSize.SMALL" />
    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      {{ label }}
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, type StyleValue } from "vue";
import type { WLTagProps } from "./types";
import { IconSize, WLIcon } from "../icon";

const { type = "primary", size = "small" } = defineProps<WLTagProps>();

/*
  NOTE: For some reason the return value is marked as possibly `undefined`,
  despite all variants and types being handled
*/
/* v8 ignore start */
const typeClasses = computed((): StyleValue => {
  switch (type) {
    case "primary":
    default:
      return "bg-accent-transparent border-accent-transparent text-accent";
    case "secondary":
      return "bg-muted border-emphasis text-emphasis";
    case "success":
      return "bg-success-transparent border-success-transparent text-success";
    case "warning":
      return "bg-warning-transparent border-warning-transparent text-warning";
    case "error":
      return "bg-error-transparent border-error-transparent text-error";
    case "neutral":
      return "bg-neutral border-neutral text-inverted";
    case "muted":
      return "bg-transparent border-theme-transparent text-inverted";
  }

  return "";
});
/* v8 ignore stop */

const sizeClasses = computed((): StyleValue => {
  switch (size) {
    case "small":
      return "px-2 py-0.5 text-xs";
    case "medium":
    default:
      return "px-2 py-1 text-xs";
    case "large":
      return "px-2 h-7";
  }
});
</script>
